import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// Import Landing Page Components
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Benefits from "./components/Benefits";
import HowItWorks from "./components/HowItWorks";
import Pricing from "./components/Pricing";
import Footer from "./components/Footer";

// Import Dashboard Components
import DashboardLayout from "./components/dashboard/DashboardLayout";
import DashboardHome from "./components/dashboard/DashboardHome";
import FileManagement from "./components/dashboard/FileManagement";
import PressureVesselGenerator from "./components/dashboard/PressureVesselGenerator";

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <About />
        <Benefits />
        <HowItWorks />
        <Pricing />
      </main>
      <Footer />
    </div>
  );
};

// Separate Pricing Page (if needed for direct access)
const PricingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <div className="pt-20">
          <Pricing />
        </div>
      </main>
      <Footer />
    </div>
  );
};

// Dashboard Pages with Layout
const Dashboard = () => (
  <DashboardLayout>
    <DashboardHome />
  </DashboardLayout>
);

const Files = () => (
  <DashboardLayout>
    <FileManagement />
  </DashboardLayout>
);

const Generate = () => (
  <DashboardLayout>
    <PressureVesselGenerator />
  </DashboardLayout>
);

const Settings = () => (
  <DashboardLayout>
    <div className="text-center py-12">
      <h2 className="text-2xl font-bold text-slate-900 mb-4">Settings</h2>
      <p className="text-slate-600">Settings page coming soon...</p>
    </div>
  </DashboardLayout>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<Navigate to="/" replace />} />
          {/* <Route path="/pricing" element={<PricingPage />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/dashboard/files" element={<Files />} />
          <Route path="/dashboard/generate" element={<Generate />} />
          <Route path="/dashboard/settings" element={<Settings />} /> */}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;